import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { AbstractModalContentComponent } from '../modal/abstract-modal-content.component';
import { AssetInfo } from '@ibe.models/asset-info.indra.model';
import { ModalService } from '@ibe/services/ui';

@Component({
	selector: 'app-slideshow',
	templateUrl: './slideshow.indra.component.html',
	styleUrls: ['./slideshow.component.scss']
})
export class INDRASlideshowComponent extends AbstractModalContentComponent implements OnInit {

	srcs: AssetInfo[];
	selected: { val: AssetInfo, pos: number };

	@ViewChild('image_scroll') $imageScroll: ElementRef;

	constructor(protected modalService: ModalService) {
		super(modalService);
		this.TYPE = 'full';
	}

	ngOnInit() {
		const imgParams: AssetInfo[] = this.data[0];
		if (imgParams && imgParams.length) {
			this.processImages(imgParams);
		}
	}

	selectImage(img: AssetInfo, index: number) {
		this.selected = { val: img, pos: index };
	}

	selectImageStyle() {
		return `url(\'${this.selected.val.path_url}\');`;
	}

	selectNext() {
		const el: HTMLBaseElement = this.$imageScroll.nativeElement;
		let curr = this.selected.pos;

		if (window.innerWidth <= 600) {
			if ((curr + 1) === this.srcs.length) {
				el.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
			} else {
				el.scrollTo({ left: el.scrollLeft + el.offsetWidth / 4, top: 0, behavior: 'smooth' });
			}
		}

		curr = (curr + 1) % this.srcs.length;
		this.selected = { val: this.srcs[curr], pos: curr };
	}

	selectPrevious() {
		const el: HTMLBaseElement = this.$imageScroll.nativeElement;
		let curr = this.selected.pos;

		if (window.innerWidth <= 600) {
			if (curr === 0) {
				el.scrollTo({ left: el.scrollLeft + el.offsetWidth * this.srcs.length, top: 0, behavior: 'smooth' });
			} else {
				el.scrollTo({ left: el.scrollLeft - el.offsetWidth / 4, top: 0, behavior: 'smooth' });
			}
		}

		curr = curr === 0 ? this.srcs.length - 1 : curr - 1;
		this.selected = { val: this.srcs[curr], pos: curr };
	}

	processImages(images: AssetInfo[]) {
		if (images.constructor != Array) {
			images = Object.assign(new Array<AssetInfo>(), [images]);
		}
		this.srcs = images;
		this.selected = { val: images[0], pos: 0 };
	}

	/**
	 * Keyboard listener
	 * Navigate on autocomlete using keyboard
	 */
	@HostListener('window:keyup', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		event.stopPropagation();
		switch (event.key) {
			case 'ArrowLeft':
				this.selectPrevious();
				break;
			case 'ArrowRight':
				this.selectNext();
				break;
			default:
				return;
		}
	}
}
